import * as THREE from 'three';

import { ThreeJSClass } from '@threeJS/threejs.helper';

import Simulator from '../simulator';

export default class Lighting extends ThreeJSClass {
  _hemiLight: THREE.HemisphereLight;
  _dirLight: THREE.DirectionalLight;

  _dirCameraLight: THREE.DirectionalLight;
  _dirCameraLightPosition: [number, number, number] = [5, 10, -10];
  _dirCameraLightPosition2: THREE.Vector3 = new THREE.Vector3(0, 0, 0);
  _ambientLight: THREE.AmbientLight;

  constructor(simulation: Simulator) {
    super(simulation);
    this._hemiLight = this._createHemiLight();
    this._dirLight = this._createDirLight();
    this._dirCameraLight = this._createDirCameraLight();
    this._ambientLight = this._createAmbientLight();

    this._setIntensity(this._simulation._isDarkMode);
    this._simulation.scene.add(this._hemiLight);
    this._simulation.scene.add(this._dirLight);
    this._simulation.camera.add(this._dirCameraLight);
    this._simulation.scene.add(this._ambientLight);
  }

  _createHemiLight() {
    const hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444, 1);
    hemiLight.position.set(0, 20, 10);
    return hemiLight;
  }

  _createDirLight() {
    const dirLight = new THREE.DirectionalLight(0xffffff, 1);
    dirLight.position.set(5, 12, -10);
    dirLight.castShadow = true;
    // dirLight.shadow.camera.top = 2;
    // dirLight.shadow.camera.bottom = -2;
    // dirLight.shadow.camera.left = -2;
    // dirLight.shadow.camera.right = 2;
    dirLight.shadow.mapSize.width = 2048;
    dirLight.shadow.mapSize.height = 2048;

    return dirLight;
  }

  _createDirCameraLight() {
    const dirLight = new THREE.DirectionalLight(0xffffff, 1);
    // dirLight.position.set(-1.5, 5, -1);
    dirLight.castShadow = true;
    dirLight.shadow.mapSize.width = 1024;
    dirLight.shadow.mapSize.height = 1024;
    // dirLight.shadow.camera.top = 2;
    // dirLight.shadow.camera.bottom = -2;
    // dirLight.shadow.camera.left = -2;
    // dirLight.shadow.camera.right = 2;
    return dirLight;
  }

  _createAmbientLight() {
    const ambientLight = new THREE.AmbientLight(0x051a2e, 1);
    return ambientLight;
  }

  _setIntensity(isDarkMode: boolean) {
    this._hemiLight.intensity = isDarkMode ? 0.5 : 1.5;
    this._dirLight.intensity = isDarkMode ? 0.8 : 1;
    this._dirCameraLight.intensity = isDarkMode ? 1 : 1.2;
    this._ambientLight.intensity = isDarkMode ? 1.2 : 1.5;
  }

  onTick(elapsedTime: number): void {}
  onToggleTheme(isDarkMode: boolean): void {
    this._setIntensity(isDarkMode);
  }
  onToggleDebug(isDebug: boolean): void {}
  dispose(): void {}
}
